import CompositeMetricView from "./CompositeMetricView";

import { ColorClass } from "@/utils/colorScale";

/**
 * Props for CompositeMetricContainer
 */
interface Props {
  /** Formatted metric value to display or null if not available */
  formattedValue: string | null;
  /** Label text describing the metric */
  label: string;
  /** Color styling configuration for the metric badge */
  styles: ColorClass;
  /** Whether screen width is below mobile breakpoint */
  isSmallScreen: boolean;
  /** Whether dark theme is active */
  isDark: boolean;
}

/**
 * Container component for displaying composite metric badges
 * @param props - Component props including metric value, label, styling, and screen size
 */
const CompositeMetricContainer = (props: Props) => {
  return <CompositeMetricView {...props} />;
};

export default CompositeMetricContainer;
